import React from 'react';
import cn from 'bem-cn';

import { RoutePaths } from '../../constants';
import { Icon, Link } from '../UI';

import './NewPromptCard.scss';

const b = cn('new-prompt-card');

export const NewPromptCard: React.FC = () => {
    return (
        <Link to={RoutePaths.NewPrompt} className={b()}>
            <div className={b('content')}>
                <div className={b('icon')}>
                    <Icon name="plus" size={24} />
                </div>
                <div className={b('text')}>
                    Добавить новый
                    <br />
                    промпт
                </div>
            </div>
        </Link>
    );
};
